// 対象要素を取得
var $root = $('#headerGlobalNav');
var $panels = $root.find('.header-globalnav-dropdown');
var $buttons = $root.find('.prim');
var $close = $root.find('.close');
/**
 * 関数定義
 */
// 初期化処理

var init = function init() {
  // ドロップダウンメニューを持つ親リンクにトリガとなるクラスを設定する
  $panels.each(function (index, elem) {
    var $panel = $(elem);
    var $button = $panel.prev();
    var panelId = 'dropdown-' + index;
    var buttonId = panelId + '_button'; // デフォルトの属性およびクラスを設定

    $panel.attr({
      'aria-hidden': 'true',
      'id': panelId,
      'aria-labelledby': buttonId
    });
    $button.attr({
      'aria-expanded': 'false',
      'id': buttonId,
      'aria-controls': panelId
    });
    $button.addClass('-button');
  });
}; // 表示切替


var switchDisplay = function switchDisplay(e) {
  // クリックされたボタンと、ボタンに連動するパネル要素を取得
  var $button = $(e.target);
  var $panel = $('#' + $button.attr('aria-controls')); // ステートに応じてボタンとパネルの属性値を変更

  if ($button.attr('aria-expanded') === 'false') {
    // 閉じている
    // すべてのボタンとパネルを閉じる
    $buttons.attr('aria-expanded', 'false');
    $panels.attr('aria-hidden', 'true'); // クリックしたボタンと該当するパネルを開く

    $button.attr('aria-expanded', 'true');
    $panel.attr('aria-hidden', 'false'); // ルート要素に属性を設定

    $('#root').attr('data-dropdown-active', 'true');
  } else {
    // 開いている
    $button.attr('aria-expanded', 'false');
    $panel.attr('aria-hidden', 'true'); // ルート要素に属性を設定

    $('#root').attr('data-dropdown-active', 'false');
  }

  e.stopPropagation(); // 親要素へのバブリングを停止

  e.preventDefault(); // 要素の標準イベントを停止
}; // メニューを閉じる


var closeMenu = function closeMenu(e) {
  var $close = $(e.target); // すべてのボタンとパネルを閉じる

  $buttons.attr('aria-expanded', 'false');
  $panels.attr('aria-hidden', 'true'); // ルート要素に属性を設定

  $('#root').attr('data-dropdown-active', 'false');
};
/**
 * 初期化処理
 */


init();
/**
 * イベント設定
 */
// トリガとなるメニューボタンクリック時に表示切替のメソッドを実行

var $trigger = $root.find('.-button');
$trigger.on('click', switchDisplay);
$close.on('click', closeMenu);